/**
 * Vehicle search result card analytics (Milestone 5 / M15).
 */
import { trackBuyerEvent } from "../buyerAnalytics";
import { toListingAnalyticsPayload } from "./listingViewModels";

export const VEHICLE_CARD_ANALYTICS_EVENTS = {
  VIEWED: "vehicle_card_viewed",
  CLICKED: "vehicle_card_clicked",
  WHATSAPP_CLICKED: "vehicle_card_whatsapp_clicked",
  SAVE_CLICKED: "vehicle_card_save_clicked",
  COMPARE_CLICKED: "vehicle_card_compare_clicked",
  DEALER_CLICKED: "vehicle_card_dealer_clicked",
  FAIR_PRICE_BADGE_CLICKED: "vehicle_card_fair_price_badge_clicked",
  RISK_BADGE_CLICKED: "vehicle_card_risk_badge_clicked",
};

export function buildVehicleCardAnalyticsPayload(listing, extra = {}) {
  if (!listing) return { ...extra };
  return toListingAnalyticsPayload(listing, {
    sourceComponent: "vehicle_search_result_card",
    listingSlug: listing.slug || listing.id || null,
    dealerName: listing.dealerName || null,
    dealerVerified: Boolean(listing.dealerVerified),
    featuredPlacement: Boolean(listing.placementId || listing.featuredPlacement),
    ...extra,
  });
}

export function trackVehicleCardEvent(eventType, listing, extra = {}) {
  trackBuyerEvent(eventType, buildVehicleCardAnalyticsPayload(listing, extra));
}
